import { WrapText } from "lucide-react";

import { SECTION_TYPES } from "@/lib/constants/sections";

import type { ServiceSection } from "@/types/sections";
import type { Service } from "@prisma/client";

const serviceDetailsSection: ServiceSection = {
  type: SECTION_TYPES.SERVICE_DETAILS,
  content: {
    header: "Service Details",
    history: "Details about the service go here!",
  },
  meta: {
    displayName: "Service Details",
    displayDescription: "Tell your customers about the services you offer.",
    displayIcon: WrapText,
  },
  aiPrompt(service: Service) {
    return `For the Service Details section of service { name: "${service.name}", blurb: "${service.blurb}" }, provide a comprehensive and informative overview of the service. Use the unstyled HTML format to structure the content in a logical and easy-to-follow manner. Include relevant details, specifications, and any other information that helps visitors understand the full scope of the service.`;
  },
};

export default serviceDetailsSection;
